import React from 'react'

import SummaryAlpha from '../../components/template/SummaryAlpha.template'

const SummaryView = () => {
    return <SummaryAlpha />
}

export default SummaryView
